import { getDisplayName } from './get-display-name';
export var createHocName = function (hocComponentName, WrappedComponent) {
    return "".concat(hocComponentName, "(").concat(getDisplayName(WrappedComponent), ")");
};
//# sourceMappingURL=create-hoc-name.js.map